module.exports = __webpack_public_path__ + "img/loader_download.7f93bc4f.gif";